/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebsitImageTypeReqVo } from './WebsitImageTypeReqVo';
import {
    WebsitImageTypeReqVoFromJSON,
    WebsitImageTypeReqVoFromJSONTyped,
    WebsitImageTypeReqVoToJSON,
    WebsitImageTypeReqVoToJSONTyped,
} from './WebsitImageTypeReqVo';

/**
 * 
 * @export
 * @interface ResponseListWebsitImageTypeReqVo
 */
export interface ResponseListWebsitImageTypeReqVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListWebsitImageTypeReqVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListWebsitImageTypeReqVo
     */
    message?: string;
    /**
     * 
     * @type {Array<WebsitImageTypeReqVo>}
     * @memberof ResponseListWebsitImageTypeReqVo
     */
    data?: Array<WebsitImageTypeReqVo>;
}

/**
 * Check if a given object implements the ResponseListWebsitImageTypeReqVo interface.
 */
export function instanceOfResponseListWebsitImageTypeReqVo(value: object): value is ResponseListWebsitImageTypeReqVo {
    return true;
}

export function ResponseListWebsitImageTypeReqVoFromJSON(json: any): ResponseListWebsitImageTypeReqVo {
    return ResponseListWebsitImageTypeReqVoFromJSONTyped(json, false);
}

export function ResponseListWebsitImageTypeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListWebsitImageTypeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(WebsitImageTypeReqVoFromJSON)),
    };
}

export function ResponseListWebsitImageTypeReqVoToJSON(json: any): ResponseListWebsitImageTypeReqVo {
    return ResponseListWebsitImageTypeReqVoToJSONTyped(json, false);
}

export function ResponseListWebsitImageTypeReqVoToJSONTyped(value?: ResponseListWebsitImageTypeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(WebsitImageTypeReqVoToJSON)),
    };
}

